export function asideFilterAccordion() {
  $(document).on("click", ".filter-block h6, .filter-block .h6", function () {
    let $this = $(this);
    let filtersList = $this.siblings("ul");
    filtersList.stop().slideToggle(200);
    $this.parent().toggleClass("expanded");
  })
}


// WEBPACK FOOTER //
// ./assets/js/modules/aside-filter-accordion.js